/** @format */

export const intRangeFilterModule = 'sis-components.number.intRangeFilter';

(function () {
    angular.module(intRangeFilterModule, []).filter('intRange', intRange);

    function intRange() {
        return function (input) {
            if (input) {
                var retval = '';
                if (input.min) {
                    retval += input.min;
                }
                if (input.min && input.max && input.min !== input.max) {
                    retval += '–';
                }
                if (input.max && input.min !== input.max) {
                    retval += input.max;
                }
                return retval;
            }
            return '';
        };
    }
})();
